import styled from 'styled-components'

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  .reminder-modal__field-container {
    display: flex;
    margin-bottom: 10px;

    &.checkbox-field {
      padding-left: 165px;
    }
  }

  .reminder-modal__field-label {
    flex: 0 0 165px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 5px;
  }

  .reminder-modal__field-label--short {
    flex: 0 0 70px;
  }

  .preview-icon {
    margin-left: 5px;
  }

  .comment-field {
    flex: 1;
    margin-top: 5px;

    div,
    form,
    textarea {
      opacity: 1 !important;
      height: 100%;
    }
  }
`
